var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_vm._v("111111111111111111111111")])
}
var staticRenderFns = []

export { render, staticRenderFns }